import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {
  WebSafeFont
} from '../../../shared/components/tag-canvas/tagging-label-canvas.component';
import {ActivatedRoute} from '@angular/router';
import {AlertComponent} from '../../../shared/components/alert/alert.component';
import {LoadingComponent} from '../../../shared/components/loading/loading.component';
import {QueryTagsService} from '../../../core/services/labeling/query-tags.service';
import {AdminLabelSkuTagType} from '../../../core/models/labeling/label-tag-type.model';
import {getHttpErrorMessage} from '../../../core/helpers/http-error-response.helper';
import {AdminLabelingSkuInfo} from '../../../core/models/labeling/label-history.model';
import {ImageCarouselComponent} from '../../../shared/components/image-carousel/image-carousel.component';
import {AccordionComponent} from '../../../shared/components/accordion/accordion.component';
import {AccordionItemComponent} from '../../../shared/components/accordion/accordion-item.component';

@Component({
  selector: 'app-tag-product',
  standalone: true,
  imports: [CommonModule, FormsModule, AlertComponent, LoadingComponent, ImageCarouselComponent, AccordionComponent, AccordionItemComponent],
  templateUrl: './tag-product.component.html',
  styleUrl: './tag-product.component.scss'
})
export class TagProductComponent implements OnInit {

  productId?: number;
  loading = false;
  error: string | null = null;

  skuInfo: AdminLabelingSkuInfo | null = null;
  labels: any[] = [];
  tagTypes: AdminLabelSkuTagType[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly labeling: QueryTagsService,
  ) {}

  ngOnInit(): void {
    this.productId = Number(this.route.snapshot.paramMap.get('skuId'));
    if (!Number.isFinite(this.productId) || (this.productId || 0) <= 0) {
      this.error = 'Sku ID inválido na rota.';
      return;
    }
    this.fetchProduct(this.productId);
  }

  private fetchProduct(id: number): void {
    this.loading = true;
    this.labeling.getBySkuId(id).subscribe({
      next: (res) => {
        this.loading = false;
        this.skuInfo = res;

        this.labels = [
          {
            id: 'productId',
            label: this.skuInfo.productId.toString(),
            bold: true,
            underline: false,
            italic: false,
            fontName: WebSafeFont.LucidaConsole,
            fontSize: 16,
            fontColor: '#ffffff'
          },
          {
            id: 'skuId',
            label: this.skuInfo.id.toString(),
            bold: true,
            underline: false,
            italic: false,
            fontName: WebSafeFont.LucidaConsole,
            fontSize: 16,
            fontColor: '#ffffff'
          },
          {
            id: 'refId',
            label: this.skuInfo.refId,
            bold: true,
            underline: false,
            italic: false,
            fontName: WebSafeFont.LucidaConsole,
            fontSize: 16,
            fontColor: '#ffffff'
          },
          {
            id: 'productName',
            label: this.skuInfo.name,
            bold: true,
            underline: false,
            italic: false,
            fontName: WebSafeFont.LucidaConsole,
            fontSize: 16,
            fontColor: '#ffffff'
          },
          {
            id: 'productValue',
            label: `R$ 99.999,99`,
            bold: true,
            underline: false,
            italic: false,
            fontName: WebSafeFont.LucidaConsole,
            fontSize: 16,
            fontColor: '#ffffff'
          },
        ];
      },
      error: (err) => {
        console.error(err);
        this.error = getHttpErrorMessage(err);
        this.loading = false;
      }
    });

    this.labeling.getTypes().subscribe({
      next: (res) => {
        this.tagTypes = res;
      },
      error: (err) => {
        console.error(err);
        this.error = getHttpErrorMessage(err);
      }
    });
  }

  getSkuImages(): string[] {
    if (this.skuInfo?.images) {
      return this.skuInfo.images;
    }
    return [];
  }

  get canvasElements(): any[] {
    return this.labels.map((l, i) => ({
      id: l.id,
      name: l.id,
      type: 'text',
      text: l.label,
      xMm: 5,
      yMm: 5 + (i * 10),
      wMm: 90,
      hMm: 8,
      zIndex: 10 + (i * 10),
      color: l.fontColor,
      fontFamily: l.fontName,
      fontSizePt: l.fontSize,
      textAlign: 'left'
    }));
  }
}
